import { render, staticRenderFns } from "./ToggleNpcEffect.vue?vue&type=template&id=279d6d7c&scoped=true&"
import script from "./ToggleNpcEffect.vue?vue&type=script&lang=js&"
export * from "./ToggleNpcEffect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "279d6d7c",
  null
  
)

export default component.exports